import { render } from "./LiquorPermit.vue?vue&type=template&id=217cabde&scoped=true"
import script from "./LiquorPermit.vue?vue&type=script&lang=js"
export * from "./LiquorPermit.vue?vue&type=script&lang=js"

import "./LiquorPermit.vue?vue&type=style&index=0&id=217cabde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217cabde"]])

export default __exports__